/**
 * @see https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=1228647551205989991-NC&hl=ja&client_type=gtm#sign_up
 */
export interface SignUpEvent {
  event: 'sign_up'
}

const create = (): SignUpEvent => ({
  event: 'sign_up',
})

export const signUpEventFactory = {
  create,
} as const
